import { useOS } from '@capsicum/common-web';
import { useEffect, useState } from 'react';

export type UseInputFocusFooterAvoidanceProps = {
	footerHeight: number;
	scrollableEntity?: {
		scrollBy: Element['scrollBy'];
	};
};

const DETECTION_DELAY = 500;
const DETECTION_BUFFER = 10;

export const useInputFocusFooterAvoidance = ({
	footerHeight,
	scrollableEntity = window
}: UseInputFocusFooterAvoidanceProps) => {
	const { isWeb } = useOS();
	const [windowHeight, setWindowHeight] = useState(0);

	useEffect(() => {
		if (isWeb) return;

		const listener = () => setWindowHeight(window.innerHeight);

		listener();

		window.addEventListener('resize', listener);

		return () => {
			window.removeEventListener('resize', listener);
		};
	}, [isWeb]);

	useEffect(() => {
		if (isWeb || !scrollableEntity) return;

		const { activeElement } = document;

		if (!activeElement || activeElement === document.body) return;

		const timeoutID = window.setTimeout(() => {
			const { height, top } = activeElement.getBoundingClientRect();
			const offset = top + height + DETECTION_BUFFER - (windowHeight - footerHeight);

			if (offset > 0) scrollableEntity.scrollBy({ behavior: 'smooth', top: offset });
		}, DETECTION_DELAY);

		return () => window.clearTimeout(timeoutID);
	}, [isWeb, footerHeight, windowHeight, scrollableEntity]);
};
